<template>
  <div>
    <v-dialog v-model="open" persistent max-width="600px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="headline">{{ t("novoWhatsApp") }}</v-card-title>
          <v-card-text>
            <v-text-field
              v-model="whatsForm.nome"
              :label="t(`nome`)"
              required
              :rules="[(v) => !!v || 'Campo obrigatório']"
            ></v-text-field>

            <v-text-field
              v-model="whatsForm.numero"
              :label="t(`numero`)"
              required
              :rules="[(v) => !!v || 'Campo obrigatório']"
            ></v-text-field>
            <v-select
              v-model="whatsForm.queue"
              :label="t(`fila`)"
              :items="filasAgente"
              required
              :rules="[(v) => !!v || 'Campo obrigatório']"
            ></v-select>
            <v-select
              v-model="instancia"
              :label="t(`instancia`)"
              :items="filas"
              required
              :rules="[(v) => !!v || 'Campo obrigatório']"
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="novoWhats()">{{
              t("continuar")
            }}</v-btn>
            <v-btn color="error" text @click="cancelar()">{{
              t("cancelar")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-snackbar v-model="snackbar" color="error" bottom>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbar = false">{{
          t("ok")
        }}</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
   
<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
export default {
  name: "Transferencia",
  props: {
    open: { type: Boolean, default: false },
    item: { type: Object, default: null },
    new: { type: Boolean, default: false },
  },
  data() {
    return {
      instancia: null,
      valid: false,
      whatsForm: {
        numero: null,
        queue: null,
        instancia: null,
        nome: null,
      },
      filas: [],
      filasAgente: [],
      snackbar: false,
      snackbarText: null,
    };
  },
  watch: {
    open(nw) {
      if (nw) {
        this.newWhats();
      }
    },
  },
  created() {
    // if(this.token) this.$router.push("/main");
  },
  computed: {
    ...mapState("xc", {
      cliente: (state) => state.cliente,
      agentes: (state) => state.agentes,
      atendimento: (state) => state.atendimento,
    }),
    ...mapState("auth", {
      user: (state) => state.user,
    }),
  },

  methods: {
    ...mapActions("xc", [
      "getDefault",
      "updateCliente",
      "transfereAtendimento",
      "setTransferenciaModal",
      "newWhatsApp",
    ]),
    cancelar() {
      this.$emit("update", false);
    },
    filterAgentes(fila) {
      if (this.agentes && this.agentes !== null) {
        let agentes = this.agentes.filter((a) => {
          let filaAux = a.filas.map((queue) => queue.fila);

          if (filaAux.indexOf(fila) !== -1) {
            return a;
          }
        });

        return agentes;
      }
    },
    filterFilas() {
      let retorno = this.filas.filter(
        (f) => f.queue_type === this.atendimento.queueTypeID
      );
      return retorno;
    },
    async getAllFilas() {
      try {
        let retorno = await this.getDefault("/api/v3/fila?max=-1&page=1");
        let aux = retorno.dados.sort(function (a, b) {
          return a.name.toLowerCase() - b.name.toLowerCase()
            ? 1
            : b.name.toLowerCase() > a.name.toLowerCase()
            ? -1
            : 0;
        });
        return aux;
      } catch (error) {
        console.error(error);
      }
    },
    async newWhats() {
      if (this.item !== null) {
        this.whatsForm.nome = this.item.nome;
        this.whatsForm.numero = this.item.numero;
      }
      let filaAux = await this.getAllFilas();
      if (filaAux) {
        if (filaAux.filter((f) => f.instance).length > 0) {
          filaAux = filaAux.filter((f) => f.instance);
        }

        let filas = filaAux
          .filter(
            (f) =>
              f.queue_type === 3 || f.queue_type === 5 || f.queue_type === 7
          )
          .map((f) => f.name);

        if (
          !this.user.pode_selecionar_instancias &&
          this.user.default_instance
        ) {
          filas = filaAux
            .filter((f) => f.name === this.user.default_instance)
            .map((f) => f.name);
        }

        this.filas = filas;
        if (filas.length > 0) this.instancia = filas[0];
        this.filasAgente = this.user.filas
          .filter(
            (f) =>
              f.queue_type === 3 || f.queue_type === 5 || f.queue_type === 7
          )
          .map((f) => f.fila);
        this.whatsForm.queue = this.filasAgente[0];
        if (this.filasAgente.length == 0) {
          this.snackbarText = this.t("fraseNenhumaFilaWhatsApp");
          this.snackbar = true;
          this.$emit("update", false);
          return;
        }

        this.filasAgente = this.filasAgente.sort(function (a, b) {
          return a.toLowerCase() - b.toLowerCase()
            ? 1
            : b.toLowerCase() > a.toLowerCase()
            ? -1
            : 0;
        });
        if (this.user.default_instance) {
          this.instancia = this.user.default_instance;
        } else {
          this.instancia = this.filasAgente[0];
        }

        this.whatsForm.instancia = this.instancia;

        // if (this.user.filas[0].queue_type === 3) {
        //   this.instancia = this.user.filas[0].fila;
        //   this.whatsForm.instancia = this.instancia;
        // }
      }
    },
    novoWhats() {
      if (!this.$refs.form.validate()) return;
      this.whatsForm.instancia = this.instancia;
      let data = this.whatsForm;
      data.agente = this.user.fullname;
      data.ramal = this.user.ramal;
      this.modalWhats = false;
      this.$emit("update", "new");
      this.newWhatsApp(data);
    },
  },
};
</script>
<style>
</style>